import { NotificationService } from '@capsicum/common';

import { Notification } from './Notification';

/**
 * An identity function that will display a success notification with
 * the given message and title as a side effect
 * @param message A message to display in the notification
 * @param title A title to display in the notification
 * @returns same as input
 */
export const successNotification =
	(message: string, title: string, blocking = false) =>
	<T,>(args: T) => {
		const result: any = NotificationService.addNotification({
			component: <Notification message={message} title={title} variant="success" />
		});

		return blocking ? result.then(() => args) : args;
	};
